import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SelectionManager from '../../../app/assets/js/shared/selections';
import ImmersiveReaderButton from '../ImmersiveReaderButton';
import ExpandScreenIcon from '../../../public/assets/images/theme-2/icons/panel-header/fullscreen.svg';
import CollapseScreenIcon from '../../../public/assets/images/theme-2/icons/panel-header/collapse.svg';
import DyslexicFontIcon from '../../../public/assets/images/theme-2/icons/panel-header/dyslexia.svg';
import CloseIcon from '../../../public/assets/images/theme-2/close-black.svg';
import ExpandScreenIconWhite from '../../../public/assets/images/theme-2/icons/panel-header/fullscreen-white.svg';
import CollapseScreenIconWhite from '../../../public/assets/images/theme-2/icons/panel-header/collapse-white.svg';
import DyslexicFontIconWhite from '../../../public/assets/images/theme-2/icons/panel-header/dyslexia-white.svg';
import CloseIconWhite from '../../../public/assets/images/theme-2/close-white.svg';

import { HeaderTools, FullScreenHeaderTool, DyslexicFontHeaderTool, CloseHeaderTool } from './styles';

const NodeContentHeaderTools = ({
  panel,
  showFullScreenTool = false,
  showVoiceOverTool = false,
  showDyslexicFontTool = true,
  viewer,
  title,
  darkMode = false,
}) => {
  const [isFullScreen, setIsFullScreen] = useState(document.querySelector('.lp--fullScreenPanel'));

  useEffect(() => {
    const initializeSelections = async () => {
      if (viewer && viewer.supportsCommunication()) {
        window.selectionManager = new SelectionManager();
        window.selectionManager.init({
          viewer,
          commentInstance: viewer.comments,
        });
      }
    };
    initializeSelections();
  }, []);

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
    document.querySelector('.content-panel').classList.toggle('lp--fullScreenPanel');
  };

  const toggleDyslexicFont = () => {
    document.dispatchEvent(new CustomEvent('toggleDyslexicFont'));
  };

  const closePanel = () => {
    panel.hide();
  };

  const topSection = (
    <HeaderTools>
      {showFullScreenTool && (
        <FullScreenHeaderTool
          onClick={toggleFullScreen}
          src={
            isFullScreen
              ? darkMode
                ? CollapseScreenIconWhite
                : CollapseScreenIcon
              : darkMode
                ? ExpandScreenIconWhite
                : ExpandScreenIcon
          }
          title={i18n.__('app_full_screen')}
        />
      )}
      {showVoiceOverTool && <ImmersiveReaderButton title={title} darkMode={darkMode} inActivity={false} />}
      {showDyslexicFontTool && (
        <DyslexicFontHeaderTool
          onClick={toggleDyslexicFont}
          src={darkMode ? DyslexicFontIconWhite : DyslexicFontIcon}
          title={i18n.__('app_dyslexic_font')}
        />
      )}
      <CloseHeaderTool onClick={closePanel} src={darkMode ? CloseIconWhite : CloseIcon} title={i18n.__('app_close')} />
    </HeaderTools>
  );

  return topSection;
};

export default NodeContentHeaderTools;

NodeContentHeaderTools.propTypes = {
  showFullScreenTool: PropTypes.bool,
  showVoiceOverTool: PropTypes.bool,
  showDyslexicFontTool: PropTypes.bool,
  panel: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  title: PropTypes.string,
  darkMode: PropTypes.bool,
};
